'use client';

import { c as _c } from "react/compiler-runtime";
import { LinkComponent } from '@/components/ui/link-component';
import { HeadlineH1 } from '@/components/ui/typography/headline-h1';
import { TeaserText } from '@/components/ui/typography/teaser-text';
import type { Locale } from '@/types/types';
import { i18nConfig } from '@/types/types';
import { useCurrentLocale } from 'next-i18n-router/client';
import type React from 'react';
interface StaticTranslationString {
  en: string;
  de: string;
  fr: string;
}
const error401TitleText: StaticTranslationString = {
  en: '401 - No Permission',
  de: '401 - Keine Berechtigung',
  fr: '401 - Pas de permission'
};
const requestingPageText: StaticTranslationString = {
  en: "You are requesting a page in for which you don't have permissions.",
  de: 'Sie fordern eine Seite an, für die Sie keine Berechtigung haben.',
  fr: "Vous demandez une page pour laquelle vous n'avez pas les permissions."
};
const pageNotAvailableP1Text: StaticTranslationString = {
  en: 'Go back to the ',
  de: 'Geh zurück zur ',
  fr: 'Retournez à la '
};
const homePageLinkText: StaticTranslationString = {
  en: 'home page',
  de: 'Startseite',
  fr: "page d'accueil"
};
const backToHomeHandler = (): void => {
  globalThis.location.href = '/';
};
export const PermissionError: React.FC = () => {
  const $ = _c(13);
  const locale = useCurrentLocale(i18nConfig) as Locale;
  const t0 = error401TitleText[locale];
  let t1;
  if ($[0] !== t0) {
    t1 = <HeadlineH1>{t0}</HeadlineH1>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = requestingPageText[locale];
  let t3;
  if ($[2] !== t2) {
    t3 = <TeaserText>{t2}</TeaserText>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = pageNotAvailableP1Text[locale];
  const t5 = homePageLinkText[locale];
  let t6;
  if ($[4] !== t5) {
    t6 = <LinkComponent onClick={backToHomeHandler} className="font-bold text-red-600" href="">{t5}</LinkComponent>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t6) {
    t7 = <TeaserText>{t4}{" "}{t6}{"."}</TeaserText>;
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t7) {
    t8 = <><main><article className="max-xl:mx-auto-auto my-8 w-full max-w-2xl px-8">{t1}{t3}{t7}</article></main></>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};